import { create } from 'zustand'

interface SignUpStepperState {
    step: number
    size: number
    setStep: (value: number) => void
    setSize: (value: number) => void
}

export const useSignUpStepperStore = create<SignUpStepperState>()(set => ({
    step: 0,
    setStep: step => set({ step }),
    size: 0,
    setSize: size => set({ size }),
}))
